import TimedEntry from "./TimedEntry";

const Education = () => (
    <>
        <h2>Education</h2>
        <TimedEntry title='University of Western Australia' period='2019 - 2021'>
            Bachelor of Biomedical Science <br />
            Double Major in Medical Sciences and Computer Science <br />
        </TimedEntry>
    </>
);

export default Education;